import { Directive, ElementRef, HostListener } from '@angular/core';

@Directive({
  selector: 'input[uppercase]'
})
export class UppercaseDirective {
  constructor(private _el: ElementRef) {}

  @HostListener('input', ['$event']) onInputChange(event) {
    const initalValue = this._el.nativeElement.value;
    this._el.nativeElement.value = event.target.value.toUpperCase();
    if (initalValue !== this._el.nativeElement.value) {
      event.stopPropagation();
    }
  }
}
